<script>
  import { createEventDispatcher } from 'svelte';

  import Input from '@components/Input.svelte';

  export let mobile = false;
  export let loading = false;
  export let searchTerm = '';
  export let handleValueChange;
  export let rightIconPath = null;
  export let autoFocus = false;

  export let hasResults = false;
  export let keywordSearch = true;
  export let showBackButton = false;
  export let showBetaLabel = false;
  let lastSearched = '';

  let searchInputEl;

  const dispatch = createEventDispatcher();

  const triggerHandleValueChange = async function () {
    if (searchInputEl.value != '') {
      rightIconPath = '/images/Close-Search.svg';
    } else {
      rightIconPath = null;
    }
    lastSearched = searchInputEl.value;

    handleValueChange(searchInputEl.value);
  };

  const triggerEnter = function () {
    dispatch('enter', { value: searchInputEl.value });
  };

  const triggerFocus = function () {
    dispatch('focus');
  };

  const triggerBlur = function () {
    dispatch('blur');
  };

  const triggerKeyUp = function (e) {
    let code = e.detail.which;

    if (code === 40) {
      dispatch('keyup-down');
    } else if (code === 38) {
      dispatch('keyup-up');
    }
  };

  const goBack = function () {
    history.back();
  };
</script>

<style style="text/scss" lang="scss">
  @import '../../vendor/design-system.scss';

  .search-input-container {
    display: flex;
    gap: 12px;

    &.mobile {
      margin-left: 20px;
      margin-right: 20px;
    }

    .ui-search {
      width: 100%;
    }

    .back-button {
      line-height: 48px;
      margin-right: 5px;
      margin-left: 5px;
    }
  }

  .search-input-container.desktop.expanded {
    :global(input) {
      border-bottom-left-radius: unset;
      border-bottom-right-radius: unset;
      border-bottom: 1px solid #ececec !important;
    }
  }

  .search-input-container.desktop {
    :global(input) {
      margin-bottom: 0px;
      border-radius: 15px;
      background: var(--neutral-white, #fff);
      box-shadow: 0px 4px 50px 0px rgba(0, 0, 0, 0.08);
      border: 0px;
      background: #fff !important;
    }
  }

  .beta-label {
    border-radius: 5px;
    background: #ebe4ff;
    height: 20px;
    width: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: #896bd9;
    font-size: 12px;
    font-weight: 700;
  }

  * :global(.input-icon-right img) {
    height: 12px !important;
    width: 12px !important;
  }

  * :global(.input-icon-left img) {
    height: 20px !important;
    width: 20px !important;
    cursor: auto !important;
  }
</style>

<div class="search-input-container {mobile ? 'mobile' : 'desktop'} {hasResults ? 'expanded' : ''}">
  <div class="ui-search">
    <form class="ui-search-input" on:submit|preventDefault|stopPropagation={() => {}}>
      <Input
        bind:inputEl={searchInputEl}
        on:keyup={triggerKeyUp}
        on:focus={triggerFocus}
        on:enter={triggerEnter}
        on:blur={triggerBlur}
        on:right-icon-click={() => {
          searchInputEl.value = '';
          triggerHandleValueChange();
        }}
        on:paste={() => {
          if (mobile) {
            setTimeout(() => {
              if (lastSearched != searchInputEl.value) {
                triggerHandleValueChange();
              }
            }, 200);
          }
        }}
        on:change={triggerHandleValueChange}
        type="text"
        disabled={loading}
        value={searchTerm}
        leftIconPath={keywordSearch ? '/images/search-icon.svg' : '/images/user-search-purple.svg'}
        rightIconPath={rightIconPath}
        placeholder={keywordSearch ? 'Search' : 'Search for a user'}
        focus={autoFocus}
        loading={loading}
        showLoadingIconOnLeftSide={false}
        withRightIconSlot={showBetaLabel}
        inputProps={{ autocomplete: 'off', autocorrect: 'off', autocapitalize: 'off' }}>
        <div slot="right-side-icon">
          <div class="beta-label">BETA</div>
        </div>
      </Input>
    </form>
  </div>
  {#if showBackButton}
    <div class="back-button" on:click={() => goBack()}>Back</div>
  {/if}
</div>
